module.exports = __webpack_public_path__ + "static/media/logo-internal-retina.0104267b.png";